module.exports = require('level-packager')(require('memdown'))
